import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { createChapter } from 'memo/actions/chapters';
import ChapterForm from 'memo/components/ChapterForm';

const mapDispatchToProps = dispatch => ({
  createChapter: fields => dispatch(createChapter(fields)),
});

const AddChapterPage = ({ createChapter }) => (
  <ChapterForm onSubmit={createChapter} />
);

AddChapterPage.propTypes = {
  createChapter: PropTypes.func.isRequired,
};

export default connect(state => state, mapDispatchToProps)(AddChapterPage);



// WEBPACK FOOTER //
// ./src/modules/memo/pages/AddChapterPage.js